module.exports = __webpack_public_path__ + "img/qrcode_for_gh_3ac4516b140d_258.09f56989.jpg";